import { render, staticRenderFns } from "./instant-points-form.vue?vue&type=template&id=701f8aa4&"
import script from "./instant-points-form.vue?vue&type=script&lang=js&"
export * from "./instant-points-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports